import { NavigateFunction } from 'react-router-dom'

export const errorRedirect = (
  url: string,
  data: object,
  navigate: NavigateFunction
) => {
  navigate(url, {
    state: data,
  })
}
